import { useEffect } from 'react';
import { requestJson } from '../../api/http';
import type { AuthSession } from '../../api/auth';

export function useSessionLifecycle(path: string) {
  useEffect(() => {
    if (path === '/login') return;
    let timer = 0;
    let stopped = false;
    let controller: AbortController | null = null;
    const check = async () => {
      controller?.abort(); controller = new AbortController();
      clearTimeout(timer);
      try {
        const session = await requestJson<AuthSession>('/auth/session', { signal: controller.signal });
        if (!stopped && Number.isFinite(session.expires_in)) {
          timer = window.setTimeout(() => void check(), Math.min(2_147_000_000, Math.max(1000, session.expires_in * 1000)));
        }
      } catch {
        // Only an HTTP 401 means expired; the client redirects that response.
        // Offline and the local unauthenticated review server are not expired sessions.
      }
    };
    const visible = () => { if (!document.hidden) void check(); };
    const stored = (event: StorageEvent) => { if (event.key === 'chanhub-auth-event') void check(); };
    window.addEventListener('pageshow', visible);
    document.addEventListener('visibilitychange', visible);
    window.addEventListener('storage', stored);
    void check();
    return () => { stopped = true; controller?.abort(); clearTimeout(timer); window.removeEventListener('pageshow', visible); document.removeEventListener('visibilitychange', visible); window.removeEventListener('storage', stored); };
  }, [path]);
}
